import { render, staticRenderFns } from "./FilterWrapper.vue?vue&type=template&id=5c6e77e0&scoped=true&"
import script from "./FilterWrapper.vue?vue&type=script&lang=js&"
export * from "./FilterWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FilterWrapper.vue?vue&type=style&index=0&id=5c6e77e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6e77e0",
  null
  
)

export default component.exports